import { Column, Entity, Index, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from 'typeorm'
import { BaseUser } from './BaseUser.entity'

@Entity('base_user_remembered_devices')
@Index('token', ['token'], { unique: true })
export class BaseUserRememberedDevice {
    @PrimaryGeneratedColumn({
        type: 'int',
        name: 'id',
        unsigned: true
    })
    id: number

    @ManyToOne(() => BaseUser, (user) => user.id, {
        onUpdate: 'CASCADE',
        onDelete: 'CASCADE',
        nullable: false
    })
    @JoinColumn({ name: 'user_id' })
    user: BaseUser

    @Column({
        type: 'varchar',
        length: 500,
        nullable: false
    })
    token: string

    @Column({
        type: 'timestamp',
        name: 'created_at',
        nullable: false,
        default: () => 'CURRENT_TIMESTAMP'
    })
    createdAt: Date

    @Column({
        type: 'tinyint',
        name: 'is_used',
        nullable: false,
        default: 0
    })
    isUsed: boolean

    constructor(init?: Partial<BaseUserRememberedDevice>) {
        Object.assign(this, init)
    }
}
